import {apiClient} from './api';

// Legacy entity endpoints return arrays rather than a total/count envelope.
export async function allPages(path,params={}) {
  const rows=[];
  for(let skip=0;;skip+=100){
    const {data}=await apiClient.get(path,{params:{...params,skip,limit:100}});
    rows.push(...data);
    if(data.length<100)return rows;
  }
}
